import React from 'react';
import { SetPassword } from './SetPassword';

export const SetPasswordPage = () => {
    return (
        <SetPassword />
    )
}